import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BEARER_ONLY } from '../interceptor/token.interceptor';
@Injectable({
  providedIn: 'root',
})
export class AddressService {

  constructor(
    private http: HttpClient
  ) { }

  getCountries(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + '/v2/public/get-refcountries');
  }

  refProvince(item): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + `/v2/public/get-refprovince?countryCode=${item}`);
  }

  refCities(item): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + `/v2/public/get-refcities?provCode=${item}`);
  }

  refBarangays(item): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + `/v2/public/get-refbrgy?citymunCode=${item}`);
  }
}
